import { normalizeQuantity } from "../../../normalizers/normalizeQuantity";
import { attachQuantityToTree, removeQuantityEverywhere, upsertQuantity } from "../helper";

export function handleAdminQuantityDefinitionDeleted(state, payload) {
    const nodeId = `q${payload.quantity_definition_id}`
    const { [nodeId]: removed, ...quantitiesById } = state.quantitiesById;

    // 2. remove everywhere
    const cleanedCategories = removeQuantityEverywhere(
        state.categoriesById,
        nodeId
    );

    return {
        ...state,
        quantitiesById,
        categoriesById: cleanedCategories,
    };
}